import { connect } from 'react-redux';
import * as R from 'ramda';
import Header from './Header';
import { getCurrentParentCompany } from './securitySlice';

const mapStateToProps = state => ({
  customerNameShort: R.o(R.prop('customerNameShort'), getCurrentParentCompany)(state),
});

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(Header);
